import React from "react";
import { styled } from "../styling";
import { ControlButton } from "../ControlButton";
import { MdClose } from "react-icons/md";
const CloseButton = styled(ControlButton) `
  opacity: 1;
  :not(:disabled):not(.disabled):hover,
  :not(:disabled):not(.disabled):hover {
    opacity: 1;
  }
`;
export const ModalClose = (props) => (React.createElement(CloseButton, Object.assign({ type: "button", title: "Close dialog", className: "close", "data-dismiss": "modal", "aria-label": "Close dialog" }, props),
    React.createElement(MdClose, null)));
//# sourceMappingURL=ModalClose.js.map